import { createSelector } from "@reduxjs/toolkit";
import { IRootState } from "../../../../store";
import { openapi } from "../../../../../openapi";
import { selectCurrentProjectId } from "../../../../global/globalSliceCommon";
import { IComment, IUserDepricated } from "@mctypes/global.types";
import { TrpcNewsItem } from "./newsapi.enhancer.ts";

const selectLayoutId = (state: IRootState) => state.projectDashboardReducer.activeLayout?._id;
const EMPTY_NEWS: TrpcNewsItem[] = [];
const EMPTY_NEWS_COMMENTS: Array<IComment & { reactions?: TrpcNewsItem["reactions"] }> = [];

const mapNewsReplyToComment = (reply: NonNullable<TrpcNewsItem["replies"]>[number]): Omit<IComment, "replies"> => ({
  _id: reply._id,
  text: reply.text,
  deleted: reply.deleted,
  createdBy: reply.createdByUser as IUserDepricated,
  createdByName: reply.createdByUser.name,
  createdDate: reply.createdAt as string,
  createdAt: reply.createdAt as string,
  reactions: reply.reactions,
});

const mapNewsToComment = (item: TrpcNewsItem): IComment & { reactions?: TrpcNewsItem["reactions"] } => ({
  _id: item._id,
  text: item.text,
  deleted: item.deleted,
  createdBy: item.createdByUser as IUserDepricated,
  createdByName: item.createdByUser.name,
  createdDate: item.createdAt as string,
  createdAt: item.createdAt as string,
  reactions: item.reactions,
  replies: item.replies?.map(mapNewsReplyToComment) ?? [],
});

export const selectHttpNews = createSelector(
  [(state: IRootState) => state, selectCurrentProjectId, selectLayoutId],
  (state, currentProjectId, layoutId): TrpcNewsItem[] | null => {
    if (!currentProjectId || !layoutId) return EMPTY_NEWS;
    const q = openapi.endpoints.getProjectByProjectIdProjectdashboardAndDashboardIdNews.select({
      projectId: currentProjectId,
      dashboardId: layoutId,
    })(state);
    return q.data ?? EMPTY_NEWS;
  },
);

export const selectNewsComments = createSelector([selectHttpNews], (news) => {
  if (news == null || news.length === 0) return EMPTY_NEWS_COMMENTS;
  return news.map(mapNewsToComment);
});
